import React from 'react';

export interface ClockIconProps {
  style?: React.CSSProperties;
}

export const ClockIcon = ({ style }: ClockIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      style={style}
    >
      <path
        d="M12.6462 13.8538L13.3538 13.1463L9.5 9.29175V4.5H8.5V9.70775L12.6462 13.8538ZM9.00325 18.5C7.75875 18.5 6.58867 18.2638 5.493 17.7915C4.3975 17.3192 3.4445 16.6782 2.634 15.8685C1.8235 15.0588 1.18192 14.1067 0.70925 13.012C0.236417 11.9175 0 10.7479 0 9.50325C0 8.25875 0.236167 7.08867 0.7085 5.993C1.18083 4.8975 1.82183 3.9445 2.6315 3.134C3.44117 2.3235 4.39333 1.68192 5.488 1.20925C6.5825 0.736417 7.75208 0.5 8.99675 0.5C10.2413 0.5 11.4113 0.736167 12.507 1.2085C13.6025 1.68083 14.5555 2.32183 15.366 3.1315C16.1765 3.94117 16.8181 4.89333 17.2908 5.988C17.7636 7.0825 18 8.25208 18 9.49675C18 10.7413 17.7638 11.9113 17.2915 13.007C16.8192 14.1025 16.1782 15.0555 15.3685 15.866C14.5588 16.6765 13.6067 17.3181 12.512 17.7908C11.4175 18.2636 10.2479 18.5 9.00325 18.5ZM9 17.5C11.2167 17.5 13.1042 16.7208 14.6625 15.1625C16.2208 13.6042 17 11.7167 17 9.5C17 7.28333 16.2208 5.39583 14.6625 3.8375C13.1042 2.27917 11.2167 1.5 9 1.5C6.78333 1.5 4.89583 2.27917 3.3375 3.8375C1.77917 5.39583 1 7.28333 1 9.5C1 11.7167 1.77917 13.6042 3.3375 15.1625C4.89583 16.7208 6.78333 17.5 9 17.5Z"
        fill="#383838"
      />
    </svg>
  );
};

export default ClockIcon;
